export default __webpack_public_path__ + "static/media/reproductive-shadow.7f40b9a3.svg";